import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/partial.svg'


const _hoisted_1 = {
  "data-testid": "step-uploadFailed",
  class: "container container--slim step--upload-result step--upload-result--failed"
}
const _hoisted_2 = { class: "container__client-zone-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-80",
    src: _imports_0
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = {
  key: 1,
  class: "row space"
}
const _hoisted_6 = {
  key: 0,
  class: "responseText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.headerOne`)), 1),
    _hoisted_3,
    (_ctx.uploadDocumentCount === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", {
            ref: "responseText",
            class: "responseText"
          }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.uploadCountOneMessage`)), 513),
          _createVNode(_component_SubmitButton, {
            "data-testid": "btn-uploadFailed-tryAgain",
            action: _ctx.action.UPLOAD_TRY_AGAIN,
            class: "button button--submit",
            data: {}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.uploadAgain`)), 1)
            ]),
            _: 1
          }, 8, ["action"]),
          _createVNode(_component_SubmitButton, {
            action: _ctx.action.UPLOAD_SUMMARY,
            "data-testid": "btn-uploadFailed-skip",
            class: "button button--skip",
            "cy-data": "go-to-personal-data",
            data: {}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.skipAndContinue`)) + " » ", 1)
            ]),
            _: 1
          }, 8, ["action"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.uploadDocumentCount === 2)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.uploadCountTwoMessage`)), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_SubmitButton, {
            action: _ctx.action.UPLOAD_SUMMARY,
            class: "button button--submit",
            "data-testid": "btn-uploadFailed-nextStep",
            "cy-data": "go-to-personal-data",
            data: {}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.nextStep`)), 1)
            ]),
            _: 1
          }, 8, ["action"])
        ]))
  ]))
}